import type { SxProps, Theme } from '@mui/material/styles';
import { LAYOUT_CONSTANTS } from '../../utils/layout-constants';

export const bottomCenterSnackbarStackSlots = {
  pwaUpdate: 0,
  collaboratorSyncError: 1,
  hardwareNotificationsStart: 2,
} as const;

export const centeredPlainSnackbarContentSx: SxProps<Theme> = {
  justifyContent: 'center',
  textAlign: 'center',
  '& .MuiSnackbarContent-message': {
    textAlign: 'center',
    width: '100%',
  },
};

export const defaultSnackbarContentSx: SxProps<Theme> = (theme) => ({
  backgroundColor: theme.vars?.palette?.background?.paper,
  color: theme.vars?.palette?.text?.primary,
});

export const bottomCenterSnackbarStackSx =
  (index: number): SxProps<Theme> =>
  (theme) => ({
    bottom: `calc(${theme.spacing(3 + index * 8)} + ${LAYOUT_CONSTANTS.BOTTOM_CONTROL_BAR_HEIGHT}px) !important`,
    [theme.breakpoints.down('sm')]: {
      bottom: `calc(${theme.spacing(2 + index * 8)} + ${LAYOUT_CONSTANTS.BOTTOM_CONTROL_BAR_HEIGHT}px) !important`,
    },
  });

// MUI resolves sx array entries left-to-right, so pass base styles before call-site overrides.
export const mergeSx = (...styles: Array<SxProps<Theme> | undefined>): SxProps<Theme> =>
  styles.flatMap((style) => {
    if (!style) {
      return [];
    }

    return Array.isArray(style) ? style : [style];
  }) as SxProps<Theme>;
